import axios from 'axios';

import type { ListUserDetailsDTO } from '@bb/domain/dist/types';

const getListingsForRole = async (input: string) => {
  const { data } = await axios.get<ListUserDetailsDTO>('listing/role/0', {
    params: {
      address: input,
      avail: 'Available',
      location: 'All',
      locationAddress: 'All',
      status: 'All',
    },
  });

  return data;
};

export default getListingsForRole;
